// DO NOT EDIT -- generated from fs/services/dx-objects/funnels.proto

import { OrgToOrgDxObjectCopyResponse } from './copy.proto';
import * as accesscontrol from '../../shared/accesscontrol';
import * as metrics from '../../api/metrics';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';
import * as search_settings from '../search-settings';
import * as segment from '../../api/segment';
import * as visualizationsettings from '../search-settings/visualizationsettings';

export namespace FunnelsPublic {

  export const GetAllFunnelsEndpoint = "/grpc/dx_objects.FunnelsPublic/GetAllFunnels";
  /** Gets all funnels */
  export function GetAllFunnels(sender: (req: GetAllFunnelsRequest, endpoint: string) => Promise<GetAllFunnelsResponse>, req: GetAllFunnelsRequest): { promise: () => Promise<GetAllFunnelsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllFunnelsEndpoint),
      endpoint: GetAllFunnelsEndpoint
    };
  }

  export const GetFunnelEndpoint = "/grpc/dx_objects.FunnelsPublic/GetFunnel";
  /** Get a specific funnel at the current version. */
  export function GetFunnel(sender: (req: GetFunnelRequest, endpoint: string) => Promise<GetFunnelResponse>, req: GetFunnelRequest): { promise: () => Promise<GetFunnelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetFunnelEndpoint),
      endpoint: GetFunnelEndpoint
    };
  }

  export const BatchGetFunnelsEndpoint = "/grpc/dx_objects.FunnelsPublic/BatchGetFunnels";
  export function BatchGetFunnels(sender: (req: BatchGetFunnelsRequest, endpoint: string) => Promise<BatchGetFunnelsResponse>, req: BatchGetFunnelsRequest): { promise: () => Promise<BatchGetFunnelsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BatchGetFunnelsEndpoint),
      endpoint: BatchGetFunnelsEndpoint
    };
  }

  export const SetFunnelEndpoint = "/grpc/dx_objects.FunnelsPublic/SetFunnel";
  /** Sets a funnel */
  export function SetFunnel(sender: (req: SetFunnelRequest, endpoint: string) => Promise<SetFunnelResponse>, req: SetFunnelRequest): { promise: () => Promise<SetFunnelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SetFunnelEndpoint),
      endpoint: SetFunnelEndpoint
    };
  }

  export const MarkFunnelViewedEndpoint = "/grpc/dx_objects.FunnelsPublic/MarkFunnelViewed";
  /** Updates the LastViewed timestamp for a funnel */
  export function MarkFunnelViewed(sender: (req: MarkFunnelViewedRequest, endpoint: string) => Promise<{}>, req: MarkFunnelViewedRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkFunnelViewedEndpoint),
      endpoint: MarkFunnelViewedEndpoint
    };
  }

  export const StarFunnelEndpoint = "/grpc/dx_objects.FunnelsPublic/StarFunnel";
  /** Stars/unstars a funnel */
  export function StarFunnel(sender: (req: StarFunnelRequest, endpoint: string) => Promise<{}>, req: StarFunnelRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StarFunnelEndpoint),
      endpoint: StarFunnelEndpoint
    };
  }

  export const ArchiveFunnelEndpoint = "/grpc/dx_objects.FunnelsPublic/ArchiveFunnel";
  /** Archives/unarchives a funnel */
  export function ArchiveFunnel(sender: (req: ArchiveFunnelRequest, endpoint: string) => Promise<ArchiveFunnelResponse>, req: ArchiveFunnelRequest): { promise: () => Promise<ArchiveFunnelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ArchiveFunnelEndpoint),
      endpoint: ArchiveFunnelEndpoint
    };
  }

  export const BulkArchiveFunnelsEndpoint = "/grpc/dx_objects.FunnelsPublic/BulkArchiveFunnels";
  export function BulkArchiveFunnels(sender: (req: BulkArchiveFunnelsRequest, endpoint: string) => Promise<BulkArchiveFunnelsResponse>, req: BulkArchiveFunnelsRequest): { promise: () => Promise<BulkArchiveFunnelsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkArchiveFunnelsEndpoint),
      endpoint: BulkArchiveFunnelsEndpoint
    };
  }

  export const CreateUnnamedFunnelEndpoint = "/grpc/dx_objects.FunnelsPublic/CreateUnnamedFunnel";
  /**
   * UnnamedFunnels store in-progress Funnel edits so they can be loaded from a url
   * Creates an UnnamedFunnel
   */
  export function CreateUnnamedFunnel(sender: (req: CreateUnnamedFunnelRequest, endpoint: string) => Promise<{}>, req: CreateUnnamedFunnelRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, CreateUnnamedFunnelEndpoint),
      endpoint: CreateUnnamedFunnelEndpoint
    };
  }

  export const GetUnnamedFunnelEndpoint = "/grpc/dx_objects.FunnelsPublic/GetUnnamedFunnel";
  /** Gets an UnnamedFunnel */
  export function GetUnnamedFunnel(sender: (req: GetUnnamedFunnelRequest, endpoint: string) => Promise<GetUnnamedFunnelResponse>, req: GetUnnamedFunnelRequest): { promise: () => Promise<GetUnnamedFunnelResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUnnamedFunnelEndpoint),
      endpoint: GetUnnamedFunnelEndpoint
    };
  }

  export const GetFunnelsAccessEndpoint = "/grpc/dx_objects.FunnelsPublic/GetFunnelsAccess";
  export function GetFunnelsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetFunnelsAccessEndpoint),
      endpoint: GetFunnelsAccessEndpoint
    };
  }
}

/** FunnelsAdmin provides administrative operations for funnels that are restricted to FullStory internal users */
export namespace FunnelsAdmin {

  export const CopyFunnelsToOrgEndpoint = "/grpc/dx_objects.FunnelsAdmin/CopyFunnelsToOrg";
  /**
   * CopyFunnelsToOrg copies funnels from one org to another
   * Only accessible to FullStory internal users
   */
  export function CopyFunnelsToOrg(sender: (req: CopyFunnelsToOrgRequest, endpoint: string) => Promise<OrgToOrgDxObjectCopyResponse>, req: CopyFunnelsToOrgRequest): { promise: () => Promise<OrgToOrgDxObjectCopyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CopyFunnelsToOrgEndpoint),
      endpoint: CopyFunnelsToOrgEndpoint
    };
  }
}

/**
 * FunnelDetail is a seat's view of a saved funnel.
 * It contains the funnel definition, audit metadata,
 * and seat-level settings such as starred, last viewed timestamp, etc.
 */
export interface FunnelDetail {
  funnel: search_settings.FunnelRecord | null;
  /** Whether the seat in the request has starred the funnel */
  starred: boolean;
  /** When the seat in the request last viewed the funnel */
  lastViewed: protobuf.timestamp | null;
}

export interface SetFunnelRequest {
  orgId: string;
  funnel: search_settings.Funnel | null;
  visibility: protoauditstore.Visibility;
}

export interface SetFunnelResponse {
  funnel: FunnelDetail | null;
}

export interface MarkFunnelViewedRequest {
  orgId: string;
  funnelId: string;
}

export interface GetAllFunnelsRequest {
  orgId: string;
  /** If true, archived funnels will also be returned. */
  includeArchived: boolean;
}

export interface GetAllFunnelsResponse {
  funnels: FunnelDetail[];
}

export interface GetFunnelRequest {
  orgId: string;
  funnelId: string;
  version: protobuf.int64;
  limit: number;
}

export interface GetFunnelResponse {
  funnel: FunnelDetail | null;
}

export interface BatchGetFunnelsRequest {
  orgId: string;
  funnelIds: string[];
}

export interface BatchGetFunnelsResponse {
  /**
   * Results are ordered in the order received from the request.
   * Not found funnels will return a Result with the id supplied in the request, but a nil FunnelRecord in the response.
   * Duplicate requested identifiers will result in duplicate results (to provide 1:1 request to result indexing).
   */
  results: BatchGetFunnelsResponse.Result[];
}

export namespace BatchGetFunnelsResponse {
  export interface Result {
    id: string;
    funnel: search_settings.FunnelRecord | null;
  }
}

export interface StarFunnelRequest {
  orgId: string;
  funnelId: string;
  /** True to star, false to unstar */
  starred: boolean;
}

export interface ArchiveFunnelRequest {
  orgId: string;
  funnelId: string;
  /** True to archive, false to unarchive */
  archived: boolean;
}

export interface ArchiveFunnelResponse {
  funnel: FunnelDetail | null;
}

export interface BulkArchiveFunnelsRequest {
  orgId: string;
  funnels: ArchiveFunnelRequest[];
}

export interface BulkArchiveFunnelsResponse {
  funnels: MaybeFunnelDetail[];
}

export interface MaybeFunnelDetail {
  funnelId: string;
  failed?: boolean;
  funnel?: FunnelDetail | null;
}

export namespace MaybeFunnelDetail {
  export enum failed_or_funnel {
    failed = 2,
    funnel = 3
  }

  export function failed_or_funnel_oneof(m: MaybeFunnelDetail): { opt: failed_or_funnel.failed, val: boolean } | { opt: failed_or_funnel.funnel, val: FunnelDetail } | null {
    if (m.failed != null) { return { opt: failed_or_funnel.failed, val: m.failed } }
    if (m.funnel != null) { return { opt: failed_or_funnel.funnel, val: m.funnel } }
    return null;
  }
}

export interface CreateUnnamedFunnelRequest {
  hash: string;
  funnel: UnnamedFunnel | null;
  orgId: string;
}

export interface GetUnnamedFunnelRequest {
  hash: string;
  orgId: string;
}

export interface GetUnnamedFunnelResponse {
  hash: string;
  funnel: UnnamedFunnel | null;
}

export enum FunnelOrientation {
  FUNNEL_ORIENTATION_VERTICAL = 0,
  FUNNEL_ORIENTATION_HORIZONTAL = 1,
  FUNNEL_ORIENTATION_TREND = 2
}

export interface UnnamedFunnel {
  funnel?: search_settings.Funnel | null;
  id?: string;
  /** @deprecated */
  segmentIds: string[];
  timeRange: segment.TimeRange | null;
  orientation: FunnelOrientation;
  dimensionSettings: metrics.DimensionSettings | null;
  disabledEvents: number[];
  timeRangeComparison: visualizationsettings.TimeRangeComparison | null;
  segments: visualizationsettings.SegmentSettings[];
  timeInterval: segment.TimeInterval;
}

export namespace UnnamedFunnel {
  export enum funnel_or_id {
    funnel = 1,
    id = 2
  }

  export function funnel_or_id_oneof(m: UnnamedFunnel): { opt: funnel_or_id.funnel, val: search_settings.Funnel } | { opt: funnel_or_id.id, val: string } | null {
    if (m.funnel != null) { return { opt: funnel_or_id.funnel, val: m.funnel } }
    if (m.id != null) { return { opt: funnel_or_id.id, val: m.id } }
    return null;
  }
}

/** Request to copy funnels from one org to another */
export interface CopyFunnelsToOrgRequest {
  sourceOrgId: string;
  destinationOrgId: string;
  funnelIds: string[];
  /**
   * Mapping of segment IDs from source to destination
   * source_id -> destination_id
   */
  segmentMappings: { [key: string]: string };
}
